module.exports = __webpack_public_path__ + "static/media/icon.debb1207.png";